import React, { useEffect, useContext } from "react";

import "firebase/firestore";
import "firebase/auth";

import { useRouter } from "next/router";
import useAuth from "context/Auth";
import { fuego } from "@nandorojo/swr-firestore";
import { ContextStore } from "context/ContextStore";

import NavBar from "components/shared/NavBar";
import Footer from "components/shared/Footer";

function Layout({ children }) {
  const router = useRouter();
  const { user, isAuthenticated } = useAuth();
  const { handleError } = useContext(ContextStore);

  useEffect(() => {
    if (router.pathname !== "/connexion/numero" && isAuthenticated && user && user.phoneNumber === null) {
      fuego
        .auth()
        .currentUser?.getIdTokenResult()
        .then((idTokenResult) => {
          if (!!idTokenResult.claims.administrator) {
            // Don't affect admin users
          } else {
            // Prompt user to add phone number
            router.push("/connexion/numero");
          }
        })
        .catch((error) => {
          handleError({ error });
        });
    }
  }, [user, router.pathname]);

  return (
    <>
      <NavBar />
      {children}
      <Footer />
    </>
  );
}

export default Layout;
